module.exports = __webpack_public_path__ + "img/_chat.04093248.svg";